'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const classNames = require( 'classnames' );
const { string } = propTypes;
const createReactClass = require('create-react-class');

const FlightLookUp = createReactClass({
  propTypes: {
    placeholderText: string,
    labelText: string,
    helpText: string,
    tracking: string,
    liClass: string,
    labelClass: string,
    inputClass: string
  },

  getDefaultProps() {
    return {
      placeholderText: 'eg. \'easyJet\', \'orlando\' or \'VS27\'',
      labelText: 'Flight (for the best offers and services)',
      helpText: 'Help find my flight: (<a href="#" id="flightFinderHelp">flight finder</a>)',
      tracking: 'flight_input',
      labelClass: '',
      inputClass: ''
    };
  },

  render() {
    const { liClass, labelClass, inputClass, placeholderText, labelText, helpText, tracking } = this.props;
    const labelClassUsed = classNames( labelClass );
    const inputClassUsed = classNames(
      inputClass,
      {
        'has-feedback': true,
        'clearfix': true
      }
    );

    return (
      <li className={ liClass }>
        <label className={ labelClassUsed }>{ labelText }</label>
        <input name="flightsearch" type="hidden" value="1" />
        <input name="flight_number_pickedlist" type="hidden" value="" />
        <input autoComplete="off" id="hxEmbedflight_number_id" name="flight_number" type="hidden" />

        <div className={ inputClassUsed }>
          <input autoComplete="off" className="col-lg-12 col-md-12 col-sm-12 col-xs-12" id="flight_number" name="flight_number_text" placeholder={ placeholderText } type="text" data-hxtrack-name={ tracking }/>
          <span className="form-control-feedback hide" id="flightClearInput">×</span>
          <div className="help-block" style={{ fontStyle: 'italic' }} dangerouslySetInnerHTML={{ __html: helpText }} />
        </div>

        <div className="modal hide fade" id="flightsModal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button className="close" data-dismiss="modal" type="button">×</button>
                <h4 className="modal-title">Flight finder<br /></h4>
              </div>

              <div className="modal-body">
                <small className="resetFlightResults pull-right" style={{ cursor: 'pointer', textDecoration: 'underline', color: '#666' }}>Reset</small>
                <div className="row row-fluid">
                  <div className="span12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <select className="span12 col-lg-12 col-md-12 col-sm-12 col-xs-12" name="airline">
                      <option>What airline are you flying with?</option>
                    </select>
                  </div>
                  <div className="span12 col-lg-12 col-md-12 col-sm-12 col-xs-12" id="destination" style={{ margin: '0px' }}>
                    <span className="span12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '3px -5px 0 5px' }}>and</span>
                    <select className="span12 col-lg-12 col-md-12 col-sm-12 col-xs-12" name="destination">
                      <option>Where are you travelling to?</option>
                    </select>
                  </div>
                </div>

                <table className="hide table-hover table table-striped table-condensed table-fixed-header" id="flightResults">
                  <thead className="row-fluid">
                    <tr>
                      <th className="hidden-xs hidden-phone" style={{ width: '15%' }}>Flight</th>
                      <th style={{ width: '40%' }}>Destination</th>
                      <th style={{ width: '15%' }}>Departure</th>
                      <th className="hidden-xs hidden-phone" style={{ width: '10%' }}>Terminal</th>
                      <th style={{ width: '20%' }}></th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
});

module.exports = FlightLookUp;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/flightLookUp.jsx